export default __webpack_public_path__ + "static/media/91ddf38e05da97ff6e91028b84314338.png";